import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";

// 默认查询数据
export const DEFAULT_QUERY_DATA = {
    ChannelId: undefined,
    Status: undefined,
};

// 默认分页数据
export const DEFAULT_PAGE_DATA = {
    Page: 1,
    PageSize: 10,
    Total: 0,
};

// 生成查询表单配置
export const generateQueryFormConfig = (options: any): FormConfigType => {
    return [
        {
            title: "通道",
            field: "ChannelId",
            type: "select",
            placeholder: "请选择通道",
            options: options?.channelOptions || [],
            fieldNames: { label: 'name', value: 'id' },
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "状态",
            field: "Status",
            type: "select",
            placeholder: "请选择状态",
            options: [
                { name: "全部", id: undefined },
                { name: "启用", id: 1 },
                { name: "禁用", id: 2 },
            ],
            style: {
                width: 200
            }
        },
    ];
};

// 生成表格列配置
export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "ID",
            dataIndex: "Id",
            key: "Id",
        },
        {
            title: "通道名称",
            dataIndex: ["Channel", "Name"],   // ✔ 读取 Channel.Name
            key: "ChannelName",
        },
        {
            title: "到账时效名称",
            dataIndex: "Name",
            key: "Name",
        },
        {
            title: "到账时效英文名称",
            dataIndex: "NameEn",
            key: "NameEn",
        },
        {
            title: "最大限额",
            dataIndex: "MaxLimit",
            key: "MaxLimit",
        },
        {
            title: "状态",
            dataIndex: "Status",
            key: "Status",
            render: (text: number) => {
                const statusMap: Record<number, string> = {
                    1: "启用",
                    2: "禁用",
                };
                return statusMap[text] || "未知";
            }
        },
        {
            title: "创建时间",
            dataIndex: "CreatedAtString",
            key: "CreatedAtString",
        },
    ];
};
